
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/components/ui/select";

interface SecurityQuestionSelectProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  label: string;
  excludeQuestion?: string;
}

export function SecurityQuestionSelect({ id, value, onChange, label, excludeQuestion }: SecurityQuestionSelectProps) {
  const photographyQuestions = [
    "What brand was your first camera?",
    "What was the subject of your first photograph?",
    "In what city did you take your favorite photo?",
    "What was your first film camera brand?",
    "What was your photography teacher's last name?",
    "What was your first photography studio name?",
    "What was the make of your first lens?",
    "Where did you develop your first roll of film?",
    "What was the location of your first photo exhibition?",
    "What was your first darkroom's location?",
    "What was your favorite photography magazine growing up?",
    "What was the brand of your first flash/strobe?",
    "What was the name of your first photography mentor?",
    "In what city did you buy your first professional camera?",
    "What was your first photography award?"
  ];

  const generalQuestions = [
    "What was your first pet's name?",
    "In which city were you born?",
    "What was the name of your first school?",
    "What is your mother's maiden name?",
    "What was your childhood nickname?",
    "What street did you grow up on?",
    "What was your maternal grandmother's first name?",
    "What was your first job title?",
    "What was your favorite book as a child?",
    "What was your childhood best friend's name?"
  ];

  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label}</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger id={id}>
          <SelectValue placeholder="Select a security question" />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            <SelectLabel>Photography Questions</SelectLabel>
            {photographyQuestions
              .filter(q => q !== excludeQuestion)
              .map((question) => (
                <SelectItem key={question} value={question}>
                  {question}
                </SelectItem>
              ))}
          </SelectGroup>
          <SelectGroup>
            <SelectLabel>General Questions</SelectLabel>
            {generalQuestions
              .filter(q => q !== excludeQuestion)
              .map((question) => (
                <SelectItem key={question} value={question}>
                  {question}
                </SelectItem>
              ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
}
